<template>
  <div class="col-lg-3 col-xl-3 busca-filtro">
    <!-- filtro mobile (mesmo filtro do desktop 1 componente apenas) -->
    <div class="busca-filtro__field show-only-mobile mb-40">
      <!-- mobile -->
      <div class="container show-only-mobile">
        <div class="row">
          <div class="col-4 p-0">
            <button
              type="button"
              class="fix__filter-button botao botao-icone botao-icone-filtro"
              data-toggle="modal"
              data-target="#busca-filtro__modal"
            >
              Filtros
            </button>
          </div>
          <div class="col-8 p-0 pl-2">
            <!-- drop down -->
            <div class="max-width-264">
              <FilterSelect
                :placeholder="currentSort"
                :items="orderingItems"
                @itemSelected="sortingTypeSelected($event)"
              />
            </div>
            <!-- fim drop down -->
          </div>
        </div>
      </div>
      <!-- Modal mobile too-->
      <div
        class="modal fade busca-filtro__modal p-0 mw-80 show-only-mobile"
        id="busca-filtro__modal"
        tabindex="-1"
        aria-labelledby="busca-filtro__modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog m-0">
          <div class="modal-content busca-filtro__modal-content">
            <!-- close modal -->
            <button class="btn" type="button" data-dismiss="modal">
              <img
                src="/static/novomundosenai/imgs/icone-fechar-modal.svg"
                class="
                  fechar-modal-icone
                  busca-filtro__modal-small-width-icon
                  mt-40
                "
                alt="fechar modal"
              />
            </button>
            <FilterContainer>
              <!-- Botão de busca -->
              <div class="container__filter-fields max-width-280">
                <button
                  @click.prevent.stop="searchOnClick()"
                  class="btn--outline-none btn__buscar"
                >
                  Buscar
                </button>
              </div>
              <!-- fim botão de busca -->
            </FilterContainer>
          </div>
        </div>
      </div>
      <!-- fim modal -->
    </div>

    <!-- filtro desktop (mesmo filtro do desktop 1 componente apenas)-->
    <div class="show-only-desktop">
      <FilterContainer>
        <!-- limpar filtros -->
        <button
          id="btn_limpar_filtros"
          class="btn__clean-filter btn--outline-none mb-5"
          @click="resetFilter()"
        >
          Limpar filtros
        </button>
        <!-- fim limpar filtros -->
      </FilterContainer>
    </div>
  </div>
</template>

<script>
import FilterContainer from '@/components/FilterContainer.vue'
import FilterSelect from '@/components/FilterSelect.vue'
import { useSearch } from '../composables/useSearch.js'

export default {
  name: 'SearchFilter',
  components: { FilterContainer, FilterSelect },
  setup() {
    const {
      cleanFilter,
      loadSearch,
      orderingItems,
      resetPagination,
      sort,
      currentSort,
    } = useSearch()
    async function resetFilter() {
      cleanFilter()
      currentSort.value = 'Ordenar'
      await loadSearch()
    }
    async function searchOnClick() {
      await loadSearch()
    }

    async function sortingTypeSelected(sortObj) {
      try {
        currentSort.value = sortObj.name
        const name = sortObj.name.toLowerCase()
        sort.value =
          name === 'tipo de produto'
            ? 'tipo_produto'
            : name === 'área'
            ? 'area'
            : name
        await loadSearch()
      } catch (error) {
        console.log(error)
      } finally {
        resetPagination()
      }
    }
    return {
      resetFilter,
      searchOnClick,
      sortingTypeSelected,
      orderingItems,
      currentSort,
    }
  },
}
</script>
